module["exports"] = [
  "Australia"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/address/default_country.js
// module id = 1123
// module chunks = 1